import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/es/storage';
import eventsReducer from './events/eventSlice';
import userReducer from './user/userSlice';
import notificationReducer from './notifications/notificationSlice'
import corporateEventSlice from './b2b/corporateEvent/corporateEventSlice';
import photoLibrarySlice from './b2b/photoLibrary/photoLibrarySlice';
import quotesReducer from './quote/quotesSlice';
import chatsReducer from './chats/chatsSlice';
import termsReducer from './terms/termsSlice';
import tablePrefsReducer from './tablePrefs/tablePrefsSlice';

const rootPersistConfig = {
  key: 'root',
  storage,
  whitelist: [''],
};

const userPersistConfig = {
  key: 'user',
  storage,
  whitelist: ['userDetails'],
};

const rootReducer = combineReducers({
  user: persistReducer(userPersistConfig, userReducer),
  events: eventsReducer,
  notifications: notificationReducer,
  corporateEvent: corporateEventSlice,
  photoLibrary: photoLibrarySlice,
  quotes: quotesReducer,
  chats: chatsReducer,
  // Not persisted: the T&Cs gate must be server-truth on every load. A
  // rehydrated 'accepted' would let a vendor past the gate on stale state.
  terms: termsReducer,
  // Hidden table columns, kept across sessions.
  tablePrefs: persistReducer({ key: 'tablePrefs', storage }, tablePrefsReducer),
});

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});

export const storePersistor = persistStore(store);
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
